import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TimeGranularity } from "services/analytics";

export type AnalyticsTab = "messages" | "agents" | "leads" | "bookings";

export interface AnalyticsState {
  tab: AnalyticsTab;
  fromDate: string; // yyyy-MM-dd
  toDate: string; // yyyy-MM-dd
  automationIds: string[];
  templateNames: string[];
  campaignIds: string[];
  granularityDelivery: TimeGranularity;
  granularityTemplates: TimeGranularity;
  granularityTopTemplates: TimeGranularity;
}

const todayIso = (): string => new Date().toISOString().slice(0, 10);

const initialState: AnalyticsState = {
  tab: "messages",
  fromDate: todayIso(),
  toDate: todayIso(),
  automationIds: [],
  templateNames: [],
  campaignIds: [],
  granularityDelivery: "day",
  granularityTemplates: "day",
  granularityTopTemplates: "day",
};

const analyticsSlice = createSlice({
  name: "analytics",
  initialState,
  reducers: {
    setTab(state, action: PayloadAction<AnalyticsTab>) {
      state.tab = action.payload;
    },
    setFromDate(state, action: PayloadAction<string>) {
      state.fromDate = action.payload;
    },
    setToDate(state, action: PayloadAction<string>) {
      state.toDate = action.payload;
    },
    setAutomationIds(state, action: PayloadAction<string[]>) {
      state.automationIds = action.payload;
    },
    setTemplateNames(state, action: PayloadAction<string[]>) {
      state.templateNames = action.payload;
    },
    setCampaignIds(state, action: PayloadAction<string[]>) {
      state.campaignIds = action.payload;
    },
    setGranularityDelivery(state, action: PayloadAction<TimeGranularity>) {
      state.granularityDelivery = action.payload;
    },
    setGranularityTemplates(state, action: PayloadAction<TimeGranularity>) {
      state.granularityTemplates = action.payload;
    },
    setGranularityTopTemplates(state, action: PayloadAction<TimeGranularity>) {
      state.granularityTopTemplates = action.payload;
    },
    hydrateFromQuery(state, action: PayloadAction<Partial<AnalyticsState>>) {
      return { ...state, ...action.payload };
    },
    resetAnalyticsState() {
      return initialState;
    },
  },
});

export const {
  setTab,
  setFromDate,
  setToDate,
  setAutomationIds,
  setTemplateNames,
  setCampaignIds,
  setGranularityDelivery,
  setGranularityTemplates,
  setGranularityTopTemplates,
  hydrateFromQuery,
  resetAnalyticsState,
} = analyticsSlice.actions;
export const analyticsSliceActions = analyticsSlice.actions;
export default analyticsSlice.reducer;
